var states = {
    PENDING: 0,
    LOADING: 1,
    LOADED: 2,
    DEAD: 3
};

export default states;